import { render, staticRenderFns } from "./BookingManager.vue?vue&type=template&id=645360da&scoped=true"
import script from "./BookingManager.vue?vue&type=script&lang=js"
export * from "./BookingManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645360da",
  null
  
)

export default component.exports